module.exports = __webpack_public_path__ + "assets/img/1206px智骑宝详情页.67cdd1cc.jpg";